// src/config/wsAccountConfig.js

// Application endpoints (prefixes /app)
export const WS_ACCOUNT_APP_ENDPOINT_BASE = '/account';
export const WS_ACCOUNT_TOPICS = { // This is for the /app/* part
    GET_STATE: '/get-state',
    UPGRADE: '/upgrade',
    EXTEND: '/extend',
    CANCEL: '/cancel',
    INITIATE_PAYMENT: '/initiate-payment', // <-- NEW TOPIC for APP endpoint
    ACCEPT_TERMS: '/accept-terms', // <-- NEW TOPIC for terms acceptance

    // API Keys topics
    API_KEYS_GET: '/api-keys/get',
    API_KEYS_CREATE: '/api-keys/create',
    API_KEYS_DELETE: '/api-keys/delete',
    API_KEYS_TOGGLE: '/api-keys/toggle',
    REFERRALS_GET: '/referrals/get',
    REFERRALS_CREATE: '/referrals/create',
    REFERRALS_DELETE: '/referrals/delete',
    PAYMENTS_GET: '/payments/get',
};

// Message types (used in the 'type' field of WebSocketMessage from backend)
export const WS_ACCOUNT_TYPES = {
    STATE: 'ACCOUNT_STATE',
    ACTION_INITIATED: 'ACCOUNT_ACTION_INITIATED', // User action (upgrade, extend) acknowledged, payment method selection may be next
    PAYMENT_URL_READY: 'ACCOUNT_PAYMENT_URL_READY', // Sent by backend when payment URL is generated
    ACTION_SUCCESS: 'ACCOUNT_ACTION_SUCCESS',     // Action (upgrade, cancel, payment) completed successfully
    ACTION_FAILED: 'ACCOUNT_ACTION_FAILED',       // Action failed
    TERMS_ACCEPTED: 'ACCOUNT_TERMS_ACCEPTED',     // <-- NEW TYPE for terms acceptance confirmation
    // ... any other specific types you might have

    // API Keys types
    API_KEYS_LIST: 'ACCOUNT_API_KEYS_LIST',
    API_KEY_CREATED: 'ACCOUNT_API_KEY_CREATED',
    API_KEY_DELETED: 'ACCOUNT_API_KEY_DELETED',
    API_KEY_TOGGLED: 'ACCOUNT_API_KEY_TOGGLED',
    API_KEY_ERROR: 'ACCOUNT_API_KEY_ERROR',

    REFERRALS_LIST: 'REFERRALS_LIST',
    REFERRAL_CREATED: 'REFERRAL_CREATED',
    REFERRAL_DELETED: 'REFERRAL_DELETED',
    PAYMENTS_LIST: 'ACCOUNT_PAYMENTS_LIST',
};


// User-specific queue destinations (subscribed by client)
// Base for user-specific queues. Spring prepends /user for user-specific routing.
// Frontend subscription path uses /queue/...
export const WS_ACCOUNT_USER_QUEUE_BASE = '/user/queue/account'; // <-- Corrected: Added /user prefix
export const WS_ACCOUNT_USER_TOPICS = { // These are appended to the base above for subscription
    STATE: '/state',   // For full state updates
    STATUS: '/status', // For action statuses, progress, payment URLs
    ERROR: '/error',   // For errors related to account actions

    // API Keys user topics
    API_KEYS_STATE: '/api-keys/state',
    API_KEYS_STATUS: '/api-keys/status',
    API_KEYS_ERROR: '/api-keys/error',
};

// Helper to construct full app endpoint path for sending messages
export const getAccountAppEndpoint = (topic) => `${WS_ACCOUNT_APP_ENDPOINT_BASE}${topic}`;

// Helper to construct full user queue topic path for subscription
export const getAccountUserQueueTopic = (topicSuffix) => `${WS_ACCOUNT_USER_QUEUE_BASE}${topicSuffix}`;


// Example usage for sending:
// sendMessage(getAccountAppEndpoint(WS_ACCOUNT_TOPICS.UPGRADE), { planId: 'premium' });

// Example usage for subscribing:
// subscribe(getAccountUserQueueTopic(WS_ACCOUNT_USER_TOPICS.STATUS), handleStatusUpdate);